import type {
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createActionsHook, createStateHook } from 'react-sweet-state';

const ContentHistoryStore = createStore({
	initialState: {
		wasTransitionedFromEditor: false,
	},
	actions: {
		setWasTransitionedFromEditor:
			(
				wasTransitionedFromEditor: boolean,
			): (({
				setState,
			}: StoreActionApi<{
				wasTransitionedFromEditor: boolean;
			}>) => void) =>
			({ setState }) => {
				setState({
					wasTransitionedFromEditor,
				});
			},
	},
	name: 'newContentHistoryState',
});

export const useNewContentHistoryState: HookStateFunction<
	{
		wasTransitionedFromEditor: boolean;
	},
	void
> = createStateHook(ContentHistoryStore);
export const useNewContentHistoryActions: HookActionsFunction<
	BoundActions<
		{
			wasTransitionedFromEditor: boolean;
		},
		{
			setWasTransitionedFromEditor: (wasTransitionedFromEditor: boolean) => ({
				setState,
			}: StoreActionApi<{
				wasTransitionedFromEditor: boolean;
			}>) => void;
		}
	>
> = createActionsHook(ContentHistoryStore);
